import { RaceCategory, RaceInstance, RaceLookupResult, ReservationPayload } from '../types';

interface ApiResult<T> {
  data: T | null;
  error: string | null;
}

export const isSupabaseConfigured = true; 

export const getAssetUrl = (
  path: string, 
  type: 'image' | 'video' = 'image', 
  optimize: boolean = true
): string => {
  // Cloudinary base URL
  const cloudName = 'dr04djvfs';
  
  // Limpiar el path (quitar barra inicial si existe)
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // Optimización automática: f_auto (formato) y q_auto (calidad)
  const transformation = optimize ? 'f_auto,q_auto/' : '';
  
  // Retornar URL de Cloudinary
  return `https://res.cloudinary.com/${cloudName}/${type}/upload/${transformation}${cleanPath}`;
};

export const listRaceCategories = async (): Promise<ApiResult<RaceCategory[]>> => {
  try {
    const response = await fetch('/api/categories');
    if (!response.ok) {
      const error = await response.json();
      return { data: null, error: error.error || 'Error al cargar categorías' };
    }
    const data = await response.json();
    return { data, error: null };
  } catch (err) {
    return { data: null, error: 'Error de conexión con el servidor' };
  }
};

export const listRaceInstances = async (date: string, category: string): Promise<ApiResult<RaceInstance[]>> => {
  try {
    const params = new URLSearchParams({ date, category });
    const response = await fetch(`/api/instances?${params.toString()}`);
    
    if (!response.ok) {
      const error = await response.json();
      return { data: null, error: error.error || 'Error al cargar horarios' };
    }

    const data = await response.json();
    return { data, error: null };
  } catch (err) {
    return { data: null, error: 'Error de conexión con el servidor' };
  }
};

export const createReservation = async (payload: ReservationPayload): Promise<ApiResult<{ booking_id: string }>> => {
  try {
    const response = await fetch('/api/reservations', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const error = await response.json();
      return { data: null, error: error.error || 'Error al crear reserva' };
    }

    const data = await response.json();
    return { data, error: null };
  } catch (err) {
    return { data: null, error: 'Error de conexión con el servidor' };
  }
};

export const verifyReservation = async (booking_id: string, code: string): Promise<ApiResult<{ access_code: string }>> => {
  try {
    const response = await fetch('/api/verify-reservation', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ booking_id, code }),
    });

    if (!response.ok) {
      const error = await response.json();
      return { data: null, error: error.error || 'Código inválido' };
    }

    const data = await response.json();
    return { data, error: null };
  } catch (err) {
    return { data: null, error: 'Error de conexión con el servidor' };
  }
};

export const findRaceByCode = async (access_code: string, email: string): Promise<ApiResult<RaceLookupResult>> => {
  try {
    const params = new URLSearchParams({ code: access_code, email });
    const response = await fetch(`/api/lookup?${params.toString()}`);

    if (!response.ok) {
      const error = await response.json();
      return { data: null, error: error.error || 'Error al buscar carrera' };
    }

    const data = await response.json();
    return { data, error: null };
  } catch (err) {
    return { data: null, error: 'Error de conexión con el servidor' };
  }
};

export const getLeaderboardSummary = async (categoryId: string): Promise<ApiResult<any>> => {
  try {
    const params = new URLSearchParams({ category: categoryId });
    const response = await fetch(`/api/leaderboard?${params.toString()}`);

    if (!response.ok) {
      const error = await response.json();
      return { data: null, error: error.error || 'Error al cargar leaderboard' };
    }

    const data = await response.json();
    return { data, error: null };
  } catch (err) {
    return { data: null, error: 'Error de conexión con el servidor' };
  }
};
